module.exports = __webpack_public_path__ + "static/media/icon-signal.907caf3d.svg";